'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2;

var _mobx = require('mobx');

var _package = require('~/package.json');

var _package2 = _interopRequireDefault(_package);

var _uaParser = require('./ua-parser');

var _uaParser2 = _interopRequireDefault(_uaParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var BrowserDetectionModel = (_class = function () {
  function BrowserDetectionModel() {
    (0, _classCallCheck3.default)(this, BrowserDetectionModel);
    this.supportedBrowsers = _package2.default.supportedBrowsers || 'browser-support-not-specified';

    _initDefineProp(this, 'ua', _descriptor, this);

    _initDefineProp(this, 'confirmed', _descriptor2, this);
  }

  (0, _createClass3.default)(BrowserDetectionModel, [{
    key: 'confirm',
    value: function confirm(event) {
      if (this.confirmed !== true) {
        this.confirmed = true;
      }
    }
  }, {
    key: 'isBrowserMobile',
    value: function isBrowserMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }, {
    key: 'browserClassInjection',
    value: function browserClassInjection() {
      var currentBrowser = this.ua.getBrowser().name.toLowerCase();
      var preSpace = ' ';
      var mobile = '';
      if (this.isBrowserMobile()) {
        mobile = ' mobile';
      }
      if (document.body.className.length === 0) {
        preSpace = '';
      }
      if (document.body.className.indexOf(currentBrowser) === -1) {
        document.body.className += preSpace + currentBrowser + mobile;
      }
    }
  }, {
    key: 'browserIsSupported',
    value: function browserIsSupported() {
      var browser = this.ua.getBrowser();
      var name = browser.name;
      var version = browser.version.split('.', 1);
      if (this.supportedBrowsers === 'browser-support-not-specified') {
        return true;
      } else if ([name] in this.supportedBrowsers && parseInt(version[0]) >= this.supportedBrowsers[name]) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'getCurrentBrowserIcon',
    value: function getCurrentBrowserIcon() {
      var currentBrowser = this.ua.getBrowser().name;
      var icon = undefined;
      switch (currentBrowser) {
        case 'Chrome':
          icon = 'fa-chrome';
          break;
        case 'Edge':
          icon = 'fa-edge';
          break;
        case 'Firefox':
          icon = 'fa-firefox';
          break;
        case 'IE':
          icon = 'fa-internet-explorer';
          break;
        case 'Safari':
          icon = 'fa-safari';
          break;
        default:
          icon = false;
      }
      return icon;
    }
  }, {
    key: 'listSupportedBrowsers',
    value: function listSupportedBrowsers() {
      var supported = this.supportedBrowsers;
      if (supported !== 'browser-support-not-specified') {
        var noSupport = '<div class="supported-browsers-title"><b>Supported Browsers: </b></div>';
        (0, _keys2.default)(supported).forEach(function (key, index) {
          noSupport += '<div class="supported-browser">' + key + ': ' + supported[key] + '+' + '</div>';
        });
        return { __html: noSupport };
      }
    }
  }, {
    key: 'displayBrowserNotSupportedMessage',
    value: function displayBrowserNotSupportedMessage() {
      if (_package2.default !== undefined) {
        if (_package2.default.browserNotSupportedMessage !== undefined && _package2.default.browserNotSupportedMessage !== '') {
          return { __html: _package2.default.browserNotSupportedMessage.toString() };
        } else {
          return this.listSupportedBrowsers();
        }
      }
    }
  }]);
  return BrowserDetectionModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'ua', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _uaParser2.default();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'confirmed', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'confirm', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'confirm'), _class.prototype)), _class);
var _default = BrowserDetectionModel;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BrowserDetectionModel, 'BrowserDetectionModel', 'src/core_modules/trc-browser-detection/browser-detection-model.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/trc-browser-detection/browser-detection-model.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/trc-browser-detection/browser-detection-model.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/trc-browser-detection/browser-detection-model.js
// module chunks = 2